import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NavbarComponent } from './navbar.component';

@NgModule({
    declarations: [
        NavbarComponent
    ],
    imports: [
        RouterModule
    ],
    exports: [
        NavbarComponent
    ]
})
export class NavbarModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/core/navbar/navbar.module.ts